import { Sun, Moon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Tooltip } from '@/components/ui/tooltip';
import { useTheme } from '@/context/ThemeContext';

interface ThemeToggleProps {
  variant?: 'default' | 'ghost' | 'outline';
  size?: 'default' | 'sm' | 'lg' | 'icon';
  showTooltip?: boolean;
  className?: string;
}

export const ThemeToggle = ({ 
  variant = 'ghost', 
  size = 'icon',
  showTooltip = true,
  className 
}: ThemeToggleProps) => {
  const { resolvedTheme, setTheme } = useTheme();

  const toggleTheme = () => {
    setTheme(resolvedTheme === 'dark' ? 'light' : 'dark');
  };

  const button = (
    <Button
      variant={variant}
      size={size}
      onClick={toggleTheme}
      className={className}
      aria-label={`Switch to ${resolvedTheme === 'dark' ? 'light' : 'dark'} mode`}
    >
      {resolvedTheme === 'dark' ? (
        <Sun className="h-5 w-5" />
      ) : (
        <Moon className="h-5 w-5" />
      )}
    </Button>
  );

  if (showTooltip) {
    return (
      <Tooltip 
        content={resolvedTheme === 'dark' ? 'Light mode' : 'Dark mode'}
        side="bottom"
      >
        {button}
      </Tooltip>
    );
  }

  return button;
};



